import { addMessages, init, locale } from 'svelte-i18n';

// English messages (default)
addMessages('en', {
  app: {
    name: 'Nonosky'
  },
  search: {
    placeholder: 'Search'
  },
  common: {
    active: 'Active',
    inactive: 'Inactive',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    update: 'Update',
    close: 'Close',
    cancel: 'Cancel',
    saveChanges: 'Save Changes',
    selectOption: 'Select an option',
    selectDate: 'Select a date',
    searchPlaceholder: 'Search ...',
    noPermission: "You don't have permission to access this section.",
    unsavedChangesPrompt: 'You have unsaved changes. Do you really want to leave?',
    deleteConfirmTitle: 'Are you sure you want to delete this {entity}?',
    deleteConfirmText: "This action can't be undone.",
    deleteConfirmButton: 'Yes, delete it!',
    previous: 'Previous',
    next: 'Next',
    itemsPerPage: 'Items per page',
    pageOf: 'Page {current} of {total}',
    user: 'User',
    asset: 'Asset',
    status: 'Status',
    returnDate: 'Return Date',
    locationOnMap: 'Location on Map',
    newAssetAssignment: 'New Asset Assignment',
    pending: 'Pending',
    confirmed: 'Confirmed',
    returned: 'Returned',
    loadingMap: 'Loading map...',
    creating: 'Creating...',
    createAssignment: 'Create Assignment',
    noCategories: 'No categories',
    noParent: 'No parent'
  },
  fields: {
    name: 'Name',
    description: 'Description',
    dataType: 'Data Type',
    state: 'Status',
    phone: 'Phone',
    address: 'Address',
    tradeName: 'Trade Name',
    maritalStatus: 'Marital Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    lastCostDate: 'Last Cost Date',
    code: 'Code',
    type: 'Type',
    price: 'Price',
    image: 'Image',
    commercialName: 'Commercial Name',
    businessName: 'Business Name'
  },
  nav: {
    dashboard: 'Dashboard',
    assetMap: 'Asset Map'
  },
  user: {
    action: 'Action',
    anotherAction: 'Another action',
    somethingElse: 'Something else here',
    logout: 'Log out',
    language: 'Language',
    english: 'English',
    spanish: 'Spanish'
  },
  login: {
    systemTagline: 'Enterprise Management System',
    title: 'Sign in with your credentials',
    emailLabel: 'Email',
    emailPlaceholder: 'Email',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Password',
    rememberMe: 'Remember me',
    signIn: 'Sign In',
    forgotPassword: 'Forgot your password?',
    createAccount: 'Create new account',
    requiredFields: 'Please fill out all fields.',
    googleError: 'Error during Google sign-in'
  },
  footer: {
    aboutUs: 'About Us',
    blog: 'Blog',
    license: 'License'
  },
  actions: {
    create: 'Create',
    exportExcel: 'Export to Excel',
    exportPDF: 'Export to PDF',
    importCSV: 'Import from CSV',
    generateQuotationPDF: 'Generate PDF Document',
    sendEmail: 'Send by Email',
    downloadProfessionalPDF: 'Download PDF Quotation',
    emailQuotationToClient: 'Send Quotation to Client Email',
    generate: 'Generate PDF',
    send: 'Send Email',
    generating: 'Generating PDF...',
    sending: 'Sending Email...',
    saveQuotation: 'Save Quotation',
    addProduct: 'Add Product',
    addService: 'Add Service'
  },
  crud: {
    management: 'Manage {title}'
  },
  crudPane: {
    editTitle: 'Edit {title}',
    createTitle: 'Create {title}',
    tabs: {
      detail: 'Detail',
      attributes: 'Attributes',
      taxes: 'Taxes',
      itemDetails: 'Item Details',
      gallery: 'Gallery',
      actions: 'Actions'
    },
    quickActions: 'Quick actions for this quotation',
    validation: {
      isRequired: '{field} is required.',
      mustBeValidNumber: '{field} must be a valid number.',
      mustBeValidEmail: '{field} must be a valid email address.'
    },
    quotation: {
      createTitle: 'Create New Quotation',
      editTitle: 'Edit Quotation',
      instructions: 'Fill in all required fields to create a quotation. You can add products and services in the "Products & Services" tab.',
      saveButton: 'Save Quotation',
      cancelButton: 'Cancel'
    }
  },
  quotation: {
    fields: {
      number: 'Quotation Number',
      date: 'Quotation Date',
      client: 'Client',
      nit: 'Tax ID (NIT)',
      phone: 'Phone Number',
      email: 'Email Address',
      total: 'Total Amount',
      clientName: 'Client Full Name',
      emailAddress: 'Client Email Address',
      product: 'Product / Service',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      attribute: 'Attribute',
      value: 'Value',
      help: {
        number: 'Unique quotation number (auto-generated)',
        date: 'Date when the quotation is created',
        nit: 'Tax Identification Number of the client',
        clientName: 'Full legal name or business name of the client',
        phone: 'Contact phone number (optional)',
        emailAddress: 'Email address where quotation will be sent (optional)',
        product: 'Select the product or service to include',
        quantity: 'Number of units or quantity',
        unitPrice: 'Price per unit',
        total: 'Total amount (automatically calculated)'
      }
    },
    tabs: {
      detail: 'Quotation Information',
      itemDetails: 'Products & Services',
      attributes: 'Additional Attributes',
      gallery: 'Images & Documents',
      actions: 'Generate & Send'
    },
    wizard: {
      step1: 'Client Information',
      step2: 'Products & Services',
      step3: 'Additional Details',
      step4: 'Review & Send',
      title: 'Create New Quotation',
      subtitle: 'Fill in the information below to create a quotation for your client'
    }
  },
  paginator: {
    previous: 'Previous',
    next: 'Next',
    itemsPerPage: 'Items per page',
    page: 'Page {current} of {total}'
  },
  assetMap: {
    filtersTitle: 'Assignment Filters',
    clearFilters: 'Clear Filters',
    statusLabel: 'Status',
    assetLabel: 'Asset (code or name)',
    userLabel: 'User (name, last name or email)',
    searchLabel: 'Search',
    assetPlaceholder: 'Search asset...',
    userPlaceholder: 'Search user...',
    searchPlaceholder: 'Search by user, asset or description...',
    headerSmall: 'Assignments Map',
    headerTitle: 'Assets Assignment Map',
    totalAssignments: 'Total Assignments',
    showing: 'Showing',
    selected: 'Selected',
    viewList: 'List',
    viewMap: 'Map',
    toggleTooltip: 'Toggle between map and list',
    newAssignment: 'New Assignment',
    editLocation: 'Edit Location',
    viewOnMap: 'View on Map',
    noResults: 'No assignments found with the current filters.',
    modal: {
      title: 'Edit Pin Location',
      currentLocation: 'Current location',
      newLocation: 'New location'
    },
    legend: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      returned: 'Returned'
    },
    statusOptions: {
      all: 'All Assignments',
      confirmed: 'Confirmed',
      pending: 'Pending',
      returned: 'Returned'
    },
    statusDisplay: {
      confirmed: 'Confirmed',
      pending: 'Pending',
      returned: 'Returned'
    },
    toasts: {
      switchingToMap: 'Switching to map view...',
      mapLoaded: 'Map view loaded',
      mapViewLoaded: 'Map view loaded',
      switchingToList: 'Switching to list view...',
      noCoords: 'This assignment has no location coordinates',
      noLocation: 'This assignment has no defined location',
      noLocationSelected: 'Please select a location on the map',
      locationReadError: 'Error reading the location for this assignment',
      locationUpdated: 'Location updated successfully',
      locationUpdateError: 'Error updating the location',
      centered: 'Map centered on selected assignment'
    },
    infoWindow: {
      title: 'Asset Assignment',
      user: 'User',
      asset: 'Asset',
      status: 'Status',
      returnDate: 'Return Date',
      assignedDate: 'Assigned Date',
      assigned: 'Assigned',
      details: 'View Details'
    },
    location: {
      updated: 'Location updated successfully',
      updateError: 'Error updating the location',
      selectOnMap: 'Please select a location on the map'
    },
    listTitle: 'Assignments',
    listSubtitle: 'Browse current assignments',
    noName: 'No name',
    noCode: 'No code',
    noLocationDefined: 'No location defined',
    statusPending: 'Pending',
    noReturnDate: 'Not specified'
  },
  entities: {
    activos: 'Assets',
    vehiculos: 'Vehicles',
    vendedores: 'Salespeople',
    usuarios: 'Users',
    transportes: 'Transportation',
    tipos: 'Types',
    sucursales: 'Branches',
    roles: 'Roles',
    proyectos: 'Projects',
    proveedores: 'Suppliers',
    productos: 'Products',
    precios: 'Prices',
    operadores: 'Operators',
    monedas: 'Currencies',
    impuestos: 'Tax Templates',
    escoltas: 'Escorts',
    empresas: 'Companies',
    documentos: 'Documents',
    corredores: 'Brokers',
    cobradores: 'Collectors',
    clientes: 'Clients',
    categoriasIva: 'Tax Categories',
    categorias: 'Categories',
    bodegas: 'Warehouses',
    atributos: 'Attributes',
    bancos: 'Banks'
  },
  dashboard: {
    assetsCreatedByMonth: 'Assets Created by Month',
    lastSixMonths: 'Last 6 months',
    totalAssets: 'TOTAL ASSETS',
    activeAssets: 'ACTIVE ASSETS',
    newAssets: 'NEW ASSETS',
    clients: 'CLIENTS',
    suppliers: 'SUPPLIERS',
    companies: 'COMPANIES',
    assetStatus: 'Asset Status',
    distributionByStatus: 'Distribution by Status',
    sinceLastMonth: 'Since last month',
    sinceYesterday: 'Since yesterday',
    recentAssets: 'Recent Assets',
    newAssetsLast30Days: 'New Assets (Last 30 days)',
    assignments: 'Assignments',
    assignmentsAndReturnDates: 'Assignments and return dates',
    assignmentsOrderedByReturnDate: 'Assignments (ordered by return date)',
    statistics: 'Statistics'
  },
  import: {
    successTitle: 'Import Successful',
    errorTitle: 'Import Error',
    setupError: 'Could not configure import',
    errorsFound: 'errors found',
    firstErrors: 'First errors:'
  },
  gallery: {
    gallery: 'Gallery',
    fileGallery: 'File Gallery',
    upload: 'Upload',
    uploading: 'Uploading...',
    uploadImages: 'Upload Images',
    dragAndDrop: 'Drag and drop images here, or',
    selectFiles: 'Select files',
    directUploadDisabled: 'Direct upload is disabled. Use URL.',
    pasteImageUrl: 'Paste image URL',
    delete: 'Delete',
    preview: 'Preview',
    galleryPreview: 'Gallery Preview'
  },
  auth: {
    name: 'Name',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    typeMessage: 'Type a message...'
  },
  chat: {
    writeMessage: 'Write a message...',
    cancelReply: 'Cancel reply'
  },
  categories: {
    title: 'Categories',
    description: 'Description',
    parentCategory: 'Parent Category',
    noParent: 'No parent (root category)',
    selectCategory: 'Select a category',
    selectCategories: 'Select categories',
    categories: 'Categories',
    noCategories: 'No categories',
    withoutCategory: 'Without category',
    categoryManagement: 'Category Management',
    productCategories: 'Product Categories',
    categoryFilter: 'Category Filter',
    filterByCategory: 'Filter by Category',
    allCategories: 'All categories',
    searchProduct: 'Search Product',
    nameOrDescription: 'Name or description...',
    clearFilters: 'Clear Filters',
    showingProducts: 'Showing {count} of {total} products',
    noProductsFound: 'No products found with the applied filters',
    categoryNavigation: 'Category Navigation',
    clickToExplore: 'Click to explore products',
    subcategories: 'Subcategories',
    products: 'Products',
    noProductsInCategory: 'No products in this category',
    backToCategories: 'Back to Categories',
    categoryReports: 'Category Reports',
    reportType: 'Report Type',
    productsByCategory: 'Products by Category',
    mostPopularCategories: 'Most Popular Categories',
    productsWithoutCategory: 'Products without Category',
    categoryStatistics: 'General Statistics',
    generateReport: 'Generate Report',
    exportCsv: 'Export CSV',
    generatingReport: 'Generating report...',
    noDataToShow: 'No data to show',
    category: 'Category',
    quantity: 'Quantity',
    totalPrice: 'Total Price',
    averagePrice: 'Average Price',
    active: 'Active',
    inactive: 'Inactive',
    productCount: 'Product Count',
    metric: 'Metric',
    value: 'Value',
    totalProducts: 'Total Products',
    productsWithCategory: 'Products with Category',
    productsWithoutCategory: 'Products without Category',
    totalCategories: 'Total Categories',
    categoriesWithProducts: 'Categories with Products',
    categoriesWithoutProducts: 'Categories without Products',
    percentageProductsWithCategory: '% Products with Category',
    percentageCategoriesWithProducts: '% Categories with Products',
    loadingProducts: 'Loading products...',
    loadingCategories: 'Loading categories...',
    errorLoadingData: 'Error loading data',
    errorGeneratingReport: 'Error generating report',
    errorLoadingCategories: 'Error loading categories',
    errorLoadingProducts: 'Error loading products',
    errorFilteringProducts: 'Error filtering products',
    errorLoadingSubcategories: 'Error loading subcategories'
  }
});

// Spanish messages
addMessages('es', {
  app: {
    name: 'Nonosky Quotations'
  },
  search: {
    placeholder: 'Buscar'
  },
  common: {
    active: 'Activo',
    inactive: 'Inactivo',
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    update: 'Actualizar',
    close: 'Cerrar',
    cancel: 'Cancelar',
    saveChanges: 'Guardar Cambios',
    selectOption: 'Seleccione una opción',
    selectDate: 'Selecciona una fecha',
    searchPlaceholder: 'Buscar ...',
    noPermission: 'No tienes permiso para acceder a esta sección.',
    unsavedChangesPrompt: 'Usted tiene cambios sin guardar. ¿Realmente desea salir?',
    deleteConfirmTitle: '¿Está seguro de eliminar este {entity}?',
    deleteConfirmText: 'Esta acción no se puede deshacer.',
    deleteConfirmButton: '¡Sí, eliminarlo!',
    previous: 'Anterior',
    next: 'Siguiente',
    itemsPerPage: 'Items por página',
    pageOf: 'Página {current} de {total}',
    user: 'Usuario',
    asset: 'Activo',
    status: 'Estado',
    returnDate: 'Fecha de Retorno',
    locationOnMap: 'Ubicación en el Mapa',
    newAssetAssignment: 'Nueva Asignación de Activo',
    pending: 'Pendiente',
    confirmed: 'Confirmada',
    returned: 'Devuelta',
    loadingMap: 'Cargando mapa...',
    creating: 'Creando...',
    createAssignment: 'Crear Asignación',
    noCategories: 'Sin categorías',
    noParent: 'Sin padres'
  },
  fields: {
    name: 'Nombre',
    description: 'Descripción',
    dataType: 'Tipo de dato',
    state: 'Estado',
    phone: 'Teléfono',
    address: 'Dirección',
    tradeName: 'Nombre Comercial',
    maritalStatus: 'Estado Civil',
    startDate: 'Fecha Inicio',
    endDate: 'Fecha Cierre',
    lastCostDate: 'Fecha Último Costo',
    code: 'Código',
    type: 'Tipo',
    price: 'Precio',
    image: 'Imagen',
    commercialName: 'Nombre Comercial',
    businessName: 'Razón Social'
  },
  nav: {
    dashboard: 'Tablero',
    assetMap: 'Mapa de Activos'
  },
  user: {
    action: 'Acción',
    anotherAction: 'Otra acción',
    somethingElse: 'Algo más aquí',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    english: 'Inglés',
    spanish: 'Español'
  },
  login: {
    systemTagline: 'Sistema de Gestión Empresarial',
    title: 'Inicia sesión con tus credenciales',
    emailLabel: 'Correo Electrónico',
    emailPlaceholder: 'Correo Electrónico',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: 'Contraseña',
    rememberMe: 'Recuérdame',
    signIn: 'Iniciar Sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    createAccount: 'Crear nueva cuenta',
    requiredFields: 'Por favor, completa todos los campos.',
    googleError: 'Error durante el inicio con Google'
  },
  footer: {
    aboutUs: 'Nosotros',
    blog: 'Blog',
    license: 'Licencia'
  },
  actions: {
    create: 'Crear',
    exportExcel: 'Exportar a Excel',
    exportPDF: 'Exportar a PDF',
    importCSV: 'Importar desde CSV',
    generateQuotationPDF: 'Generar Documento PDF',
    sendEmail: 'Enviar por Correo',
    downloadProfessionalPDF: 'Descargar Cotización PDF',
    emailQuotationToClient: 'Enviar Cotización al Correo del Cliente',
    generate: 'Generar PDF',
    send: 'Enviar Correo',
    generating: 'Generando PDF...',
    sending: 'Enviando Correo...',
    saveQuotation: 'Guardar Cotización',
    addProduct: 'Agregar Producto',
    addService: 'Agregar Servicio'
  },
  crud: {
    management: 'Gestión de {title}'
  },
  crudPane: {
    editTitle: 'Editar {title}',
    createTitle: 'Crear {title}',
    tabs: {
      detail: 'Detalle',
      attributes: 'Atributos',
      taxes: 'Impuestos',
      itemDetails: 'Detalles del Item',
      gallery: 'Galería',
      actions: 'Acciones'
    },
    quickActions: 'Acciones rápidas para esta cotización',
    validation: {
      isRequired: '{field} es requerido.',
      mustBeValidNumber: '{field} debe ser un número válido.',
      mustBeValidEmail: '{field} debe ser un correo electrónico válido.'
    },
    quotation: {
      createTitle: 'Crear Nueva Cotización',
      editTitle: 'Editar Cotización',
      instructions: 'Complete todos los campos requeridos para crear una cotización. Puede agregar productos y servicios en la pestaña "Productos y Servicios".',
      saveButton: 'Guardar Cotización',
      cancelButton: 'Cancelar'
    }
  },
  quotation: {
    fields: {
      number: 'Número de Cotización',
      date: 'Fecha de Cotización',
      client: 'Cliente',
      nit: 'NIT (Número de Identificación Tributaria)',
      phone: 'Teléfono de Contacto',
      email: 'Correo Electrónico',
      total: 'Monto Total',
      clientName: 'Nombre Completo del Cliente',
      emailAddress: 'Correo Electrónico del Cliente',
      product: 'Producto / Servicio',
      quantity: 'Cantidad',
      unitPrice: 'Precio Unitario',
      attribute: 'Atributo',
      value: 'Valor',
      help: {
        number: 'Número único de cotización (se genera automáticamente)',
        date: 'Fecha en que se crea la cotización',
        nit: 'Número de Identificación Tributaria del cliente',
        clientName: 'Nombre completo legal o razón social del cliente',
        phone: 'Número de teléfono de contacto (opcional)',
        emailAddress: 'Correo electrónico donde se enviará la cotización (opcional)',
        product: 'Seleccione el producto o servicio a incluir',
        quantity: 'Número de unidades o cantidad',
        unitPrice: 'Precio por unidad',
        total: 'Monto total (se calcula automáticamente)'
      }
    },
    tabs: {
      detail: 'Información de Cotización',
      itemDetails: 'Productos y Servicios',
      attributes: 'Atributos Adicionales',
      gallery: 'Imágenes y Documentos',
      actions: 'Generar y Enviar'
    },
    wizard: {
      step1: 'Información del Cliente',
      step2: 'Productos y Servicios',
      step3: 'Detalles Adicionales',
      step4: 'Revisar y Enviar',
      title: 'Crear Nueva Cotización',
      subtitle: 'Complete la información a continuación para crear una cotización para su cliente'
    }
  },
  paginator: {
    previous: 'Anterior',
    next: 'Siguiente',
    itemsPerPage: 'Items por página',
    page: 'Página {current} de {total}'
  },
  assetMap: {
    filtersTitle: 'Filtros de Asignaciones',
    clearFilters: 'Limpiar Filtros',
    statusLabel: 'Estado',
    assetLabel: 'Activo (código o nombre)',
    userLabel: 'Usuario (nombre, apellido o email)',
    searchLabel: 'Buscar',
    assetPlaceholder: 'Buscar activo...',
    userPlaceholder: 'Buscar usuario...',
    searchPlaceholder: 'Buscar por usuario, activo o descripción...',
    headerSmall: 'Mapa de Asignaciones',
    headerTitle: 'Mapa de Asignaciones de Activos',
    totalAssignments: 'Total de Asignaciones',
    showing: 'Mostrando',
    selected: 'Seleccionado',
    viewList: 'Lista',
    viewMap: 'Mapa',
    toggleTooltip: 'Alternar entre mapa y lista',
    newAssignment: 'Nueva Asignación',
    editLocation: 'Editar Ubicación',
    viewOnMap: 'Ver en Mapa',
    noResults: 'No se encontraron asignaciones con los filtros actuales.',
    modal: {
      title: 'Editar Ubicación del Pin',
      currentLocation: 'Ubicación actual',
      newLocation: 'Nueva ubicación'
    },
    legend: {
      pending: 'Pendientes',
      confirmed: 'Confirmadas',
      returned: 'Devueltas'
    },
    statusOptions: {
      all: 'Todas las Asignaciones',
      confirmed: 'Confirmadas',
      pending: 'Pendientes',
      returned: 'Devueltas'
    },
    statusDisplay: {
      confirmed: 'Confirmada',
      pending: 'Pendiente',
      returned: 'Devuelta'
    },
    toasts: {
      switchingToMap: 'Cambiando a vista de mapa...',
      mapLoaded: 'Vista de mapa cargada',
      mapViewLoaded: 'Vista de mapa cargada',
      switchingToList: 'Cambiando a vista de lista...',
      noCoords: 'Esta asignación no tiene coordenadas de ubicación',
      noLocation: 'Esta asignación no tiene ubicación definida',
      noLocationSelected: 'Por favor selecciona una ubicación en el mapa',
      locationReadError: 'Error al leer la ubicación de esta asignación',
      locationUpdated: 'Ubicación actualizada correctamente',
      locationUpdateError: 'Error al actualizar la ubicación',
      centered: 'Mapa centrado en la asignación seleccionada'
    },
    infoWindow: {
      title: 'Asignación de Activo',
      user: 'Usuario',
      asset: 'Activo',
      status: 'Estado',
      returnDate: 'Fecha de Retorno',
      assignedDate: 'Fecha de Asignación',
      assigned: 'Asignado',
      details: 'Ver Detalles'
    },
    location: {
      updated: 'Ubicación actualizada correctamente',
      updateError: 'Error al actualizar la ubicación',
      selectOnMap: 'Por favor selecciona una ubicación en el mapa'
    },
    listTitle: 'Asignaciones',
    listSubtitle: 'Explora las asignaciones actuales',
    noName: 'Sin nombre',
    noCode: 'Sin código',
    noLocationDefined: 'Sin ubicación definida',
    statusPending: 'Pendiente',
    noReturnDate: 'No especificada'
  },
  entities: {
    activos: 'Activos',
    vehiculos: 'Vehículos',
    vendedores: 'Vendedores',
    usuarios: 'Usuarios',
    transportes: 'Transportes',
    tipos: 'Tipos',
    sucursales: 'Sucursales',
    roles: 'Roles',
    proyectos: 'Proyectos',
    proveedores: 'Proveedores',
    productos: 'Productos',
    precios: 'Precios',
    operadores: 'Operadores',
    monedas: 'Monedas',
    impuestos: 'Plantillas de Impuestos',
    escoltas: 'Escoltas',
    empresas: 'Empresas',
    documentos: 'Documentos',
    corredores: 'Corredores',
    cobradores: 'Cobradores',
    clientes: 'Clientes',
    categoriasIva: 'Categorías IVA',
    categorias: 'Categorías',
    bodegas: 'Bodegas',
    atributos: 'Atributos',
    bancos: 'Bancos'
  },
  dashboard: {
    assetsCreatedByMonth: 'Activos Creados por Mes',
    lastSixMonths: 'Últimos 6 meses',
    totalAssets: 'TOTAL DE ACTIVOS',
    activeAssets: 'ACTIVOS ACTIVOS',
    newAssets: 'NUEVOS ACTIVOS',
    clients: 'CLIENTES',
    suppliers: 'PROVEEDORES',
    companies: 'EMPRESAS',
    assetStatus: 'Estado de Activos',
    distributionByStatus: 'Distribución por Estado',
    sinceLastMonth: 'Desde el mes pasado',
    sinceYesterday: 'Desde ayer',
    recentAssets: 'Activos Recientes',
    newAssetsLast30Days: 'Nuevos Activos (Últimos 30 días)',
    assignments: 'Asignaciones',
    assignmentsAndReturnDates: 'Asignaciones y fechas de retorno',
    assignmentsOrderedByReturnDate: 'Asignaciones (ordenadas por fecha de retorno)',
    statistics: 'Estadísticas'
  },
  import: {
    successTitle: 'Importación Exitosa',
    errorTitle: 'Error en la Importación',
    setupError: 'No se pudo configurar la importación',
    errorsFound: 'errores encontrados',
    firstErrors: 'Primeros errores:'
  },
  gallery: {
    gallery: 'Galería',
    fileGallery: 'Galería de Archivos',
    upload: 'Subir',
    uploading: 'Subiendo...',
    uploadImages: 'Subir imágenes',
    dragAndDrop: 'Arrastra y suelta imágenes aquí, o',
    selectFiles: 'Seleccionar archivos',
    directUploadDisabled: 'La subida directa está deshabilitada. Usa URL.',
    pasteImageUrl: 'Pegar URL de imagen',
    delete: 'Eliminar',
    preview: 'Vista previa',
    galleryPreview: 'Vista previa de galería'
  },
  auth: {
    name: 'Nombre',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    fullName: 'Nombre Completo',
    typeMessage: 'Escribe un mensaje...'
  },
  chat: {
    writeMessage: 'Escribe un mensaje...',
    cancelReply: 'Cancelar respuesta'
  },
  categories: {
    title: 'Categorías',
    description: 'Descripción',
    parentCategory: 'Categoría Padre',
    noParent: 'Sin padres (categoría raíz)',
    selectCategory: 'Seleccionar una categoría',
    selectCategories: 'Seleccionar categorías',
    categories: 'Categorías',
    noCategories: 'Sin categorías',
    withoutCategory: 'Sin categoría',
    categoryManagement: 'Gestión de Categorías',
    productCategories: 'Categorías de Productos',
    categoryFilter: 'Filtro de Categorías',
    filterByCategory: 'Filtrar por Categoría',
    allCategories: 'Todas las categorías',
    searchProduct: 'Buscar Producto',
    nameOrDescription: 'Nombre o descripción...',
    clearFilters: 'Limpiar Filtros',
    showingProducts: 'Mostrando {count} de {total} productos',
    noProductsFound: 'No se encontraron productos con los filtros aplicados',
    categoryNavigation: 'Navegación por Categorías',
    clickToExplore: 'Haz clic para explorar productos',
    subcategories: 'Subcategorías',
    products: 'Productos',
    noProductsInCategory: 'No hay productos en esta categoría',
    backToCategories: 'Volver a Categorías',
    categoryReports: 'Reportes de Categorías',
    reportType: 'Tipo de Reporte',
    productsByCategory: 'Productos por Categoría',
    mostPopularCategories: 'Categorías Más Populares',
    productsWithoutCategory: 'Productos sin Categoría',
    categoryStatistics: 'Estadísticas Generales',
    generateReport: 'Generar Reporte',
    exportCsv: 'Exportar CSV',
    generatingReport: 'Generando reporte...',
    noDataToShow: 'No hay datos para mostrar',
    category: 'Categoría',
    quantity: 'Cantidad',
    totalPrice: 'Precio Total',
    averagePrice: 'Precio Promedio',
    active: 'Activo',
    inactive: 'Inactivo',
    productCount: 'Cantidad de Productos',
    metric: 'Métrica',
    value: 'Valor',
    totalProducts: 'Total de Productos',
    productsWithCategory: 'Productos con Categoría',
    productsWithoutCategory: 'Productos sin Categoría',
    totalCategories: 'Total de Categorías',
    categoriesWithProducts: 'Categorías con Productos',
    categoriesWithoutProducts: 'Categorías sin Productos',
    percentageProductsWithCategory: '% Productos con Categoría',
    percentageCategoriesWithProducts: '% Categorías con Productos',
    loadingProducts: 'Cargando productos...',
    loadingCategories: 'Cargando categorías...',
    errorLoadingData: 'Error cargando datos',
    errorGeneratingReport: 'Error generando reporte',
    errorLoadingCategories: 'Error cargando categorías',
    errorLoadingProducts: 'Error cargando productos',
    errorFilteringProducts: 'Error filtrando productos',
    errorLoadingSubcategories: 'Error cargando subcategorías'
  }
});

// Initialize i18n with default English, persist user selection
const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null;
init({
  fallbackLocale: 'en',
  initialLocale: stored || 'en'
});

export function setLanguage(lang) {
  locale.set(lang);
  try {
    localStorage.setItem('locale', lang);
  } catch (e) {
    // ignore persistence errors
  }
}


